<template>
  <div id="page">
    <div id="outer">
      <div id="title-div">
        <div id="allSpan-div">
          <div id="span-div1">
            <span id="title-span">查位次</span>
          </div>
        </div>

        <div id="select-banner" style="margin-right: 56px;">
          <el-form
            :model="form"
            inline
            style="display: flex; align-items: center"
            label-width="80px">
            <el-form-item label="省份" style="display: flex;">
                  <el-select @change="chaSeat(),OneQuarter_index()" v-model="form.province" placeholder="请选择省份" size="small"  style="width:120px;">
                    <el-option v-for="item in cityData" :key="item.title" :label="item.title" :value="item.title">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="组别" style="display: flex;">
                  <el-select @change="chaSeat(),OneQuarter_index()" v-model="form.group_d" placeholder="请选择" size="small"  style="width:120px;">
                    <el-option v-for="item in onequarter_group" :key="item" :label="item" :value="item">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="年份" style="display: flex;">
                  <el-select @change="chaSeat(),OneQuarter_index()" v-model="form.year" placeholder="请选择" size="small"  style="width:120px;">
                    <el-option v-for="item in yearArr" :key="item" :label="item" :value="item">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="分数" style="display: flex;">
                  <el-input placeholder="请输入分数" type="number" v-model="form.score" @keyup.enter.native="chaSeat()" clearable=""></el-input>
                </el-form-item>
            <el-form-item style="display: flex">
              <el-button type="success" size="small" @click="chaSeat(),OneQuarter_index()">
                查询
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <div style="width:90%;height: 78%;overflow-y: auto;margin: 0 auto;" v-loading="loading">
         <div>
             <h4>查看结果</h4>
             <div class="result" style="height: 100px;">
                <div v-if="!result.scroe" style="color: #666;width: 95%;margin: 0 auto;">
                   请右上角输入分数进行查询
                </div>
                <div class="stack-info" v-if="result.scroe" style="width: 95%;margin: 0 auto;">
                  <div class="gk-score">
                     <span>高考分数：{{form.score || "请输入分数"}}</span>
                  </div>
                  <div class="gk-rank">
                     <div class="item">同分人数：{{result.even_score || "--"}}人</div>
                     <div class="item">位次：{{result.seat || "--"}}名</div>
                  </div>
                </div>
             </div>
             <h4>
              <span style="color: red;">*</span>
              重要提示
             </h4>
             <div style="color: #666;font-size: 18px;line-height: 40px;">
              <div>1、位次查询结果根据各省考试院发布的一分一段表计算。</div>
              <div>2、在正式填报时，请以各省教育考试院发布的数据为准，本平台数据仅供参考。</div>
             </div>
         </div>

<!--         <div style="width: 100%;">
           <h4>一分一档表</h4>
           <el-table :data="list" border style="width: 100%" :header-cell-style="{background:'#f5f5f5'}" v-loading="loading">
            <el-table-column prop="scroe" label="分数" align="center">
            </el-table-column>
            <el-table-column :prop="form.group_d=='物理组'?'wuliNum':'lishiNum'" label="本段人数" align="center">
            </el-table-column>
            <el-table-column :prop="form.group_d=='物理组'?'wuliSum':'lishiSum'" label="累计人数" align="center">
            </el-table-column>
            </el-table>
        </div> -->

      </div>


    </div>
  </div>
</template>
<script>
import cityJson from "@/utils/city.json";
import { selectYear,chaSeat,OneQuarter_index,groupFind } from "@/api/gw/zonghe.js"
export default {
  data() {
    return {
      cityData: cityJson,
      form:{
          province:"河北",//省份
					group_d:"",//组别物理科目组合
					score:"",//分数
					year:"",//年份
      },
      loading:false,
      yearArr:[],//年份为：当前年+1 当前年  当前年-1 当前年-2  当前年-3
      result:{},
      list:[],
      onequarter_group:[],
    };
  },
  mounted() {
    this.groupFind();
    this.selectYear();
  },
  methods: {
    chaSeat(){
       if(!this.form.score){
        this.$message.error("请输入分数");
        return;
       }
       this.loading = false
       const examTypeRaw = localStorage.getItem('selectedExamType');
       const examType = ['1','2','3'].includes(String(examTypeRaw)) ? String(examTypeRaw) : '1';
       const params = { ...this.form, examType };
       chaSeat(params).then(res=>{
        this.result = res.data
        this.form.year = res.data.year
       }).finally(()=>{
        this.loading = false
       })
    },
    groupFind(){
      const examTypeRaw = localStorage.getItem('selectedExamType');
      const examType = ['1','2','3'].includes(String(examTypeRaw)) ? String(examTypeRaw) : '1';
      groupFind({ examType }).then((res)=>{
        console.log("字典表",res.data);
        this.onequarter_group = res.data.onequarter_group
      })
    },
    //一分一档表
    OneQuarter_index(){
      const examTypeRaw = localStorage.getItem('selectedExamType');
      const examType = ['1','2','3'].includes(String(examTypeRaw)) ? String(examTypeRaw) : '1';
      const baseParams = {
        province:this.form.province,
        group_d:this.form.group_d=="物理组"?"物理科目组合":"历史科目组合",
        year:this.form.year
      };
      const params = { ...baseParams, examType };
      OneQuarter_index(params).then(res=>{
        this.list = res.data
      })
    },
    selectYear(){
      selectYear({}).then(res=>{
        if(res.data){
						// this.form.year = res.data[0]
            this.OneQuarter_index();//获取一分一档表
					}
					this.yearArr = res.data
      })
    },
  },
};
</script>
<style lang="scss" scoped>
.result{
  width: 100%;
  background: #fff9f2;
  padding-top: 20px;
  padding-bottom: 20px;
  margin-bottom: 30px;
  .stack-info{
    .gk-rank{
      .item{
        display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 12px;
    color: #000;
      }
    }
     .gk-score{
      padding-bottom: 12px;
    border-bottom: 1px solid #d9d9d9;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
     }
  }
}
@import '../scss/index.scss';

::v-deep .el-table {
  overflow: visible !important;
}

::v-deep .el-table__header-wrapper {
  position: sticky !important;
  top: 0 !important; //这个值根据实际情况而定
  z-index: 10 !important;
}
</style>




// WEBPACK FOOTER //
// src/views/comprehensive/components/seat.vue